import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faSearch } from '@fortawesome/free-solid-svg-icons';

import './Login.css';

import authContext from '../../context/authentication/authContext';
import Routes from '../../utils/Routes';

import Swal from 'sweetalert2';

function Login() {

    const aContext = useContext(authContext);
    const { mensaje, iniciarSesion, usuarioAutenticado } = aContext;
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const [usuarioState, setUsuarioState] = useState({ userName: "", password: "" });

    const alerta = () => {
        if (mensaje != null && mensaje != '') {
            Swal.fire({
                text: mensaje,
                icon: 'warning',
                confirmButtonText: 'OK'
            })
        }
    }

    useEffect(() => {
        if (mensaje != null)
            alerta();
    }, [mensaje]);

    const onSubmit = async () => {
        setLoading(true);
        try {
            const resp = await iniciarSesion(usuarioState);

            if (!resp.autenticado) throw Error(resp.error.response.data.message);

            await usuarioAutenticado();
            navigate(Routes.tablero);
            setLoading(false);
        } catch (error) {
            console.log('ERROR EN INICIAR SESION');
            console.log(error);

            Swal.fire({
                title: error.message,
                text: 'Revise sus credenciales de autenticacion',
                icon: 'error'
            })
            setLoading(false);
        }
    }

    const handlerInputUser = userText => setUsuarioState({ ...usuarioState, 'userName': userText.target.value });
    const handlerInputPass = passText => { setUsuarioState({ ...usuarioState, 'password': passText.target.value }); }

    return (
        <div className='container-login'>
            <div className="card-login">
                <div className="containerImg">
                    <FontAwesomeIcon icon={faSearch} style={{ fontSize: '4rem', color: '#3d4d87' }} />
                    <h1 className="logoTitle">XertuX Discover</h1>
                </div>
                <div className='containerForm'>
                    <div className='inputsContainer'>
                        <div className="containerInput">
                            <input
                                className="textInput"
                                id="username"
                                placeholder="Usuario"
                                type="text"
                                name="username"
                                onChange={handlerInputUser}
                            />
                        </div>
                        <div className="containerInput containerInputPassword">
                            <input
                                className="textInput"
                                id="password"
                                placeholder="Clave"
                                type={showPassword ? 'text' : 'password'}
                                name="user_password"
                                onChange={handlerInputPass}
                                onKeyDown={(keyName) => keyName.key === 'Enter' ? onSubmit() : null}
                            />
                            <FontAwesomeIcon
                                className='showPasswordBtn'
                                icon={showPassword ? faEyeSlash : faEye}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                    </div>

                    <div className="submitOptionsContainerStyle">
                        <button
                            id="myBtn"
                            className={`btnSubmitLoginStyle ${usuarioState.userName == "" || usuarioState.password == "" ? 'disabled' : ''}`}
                            disabled={usuarioState.userName == "" || usuarioState.password == ""}
                            onClick={onSubmit}
                        >
                            {loading ? <span>...</span> : 'Ingresar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
